import type { MappedCustomDataServiceObjectField, MappedServiceObjectData } from 'common/models';
import { LabeledText } from 'components';
import type { ServiceObjectInCustomer } from 'pages/serviceObjects/models';
import React from 'react';

import ServiceObjectLabeledText from '../ServiceObjectLabeledText';

interface Props {
  reportData: MappedServiceObjectData;
  serviceObject: ServiceObjectInCustomer;
  columnsWidthArray?: string[];
  index: number;
}

const ServiceObjectSectionItem: React.FC<Props> = (props): React.ReactElement => {
  const { reportData, serviceObject, columnsWidthArray, index } = props;

  const flexWidth = columnsWidthArray
    ? columnsWidthArray[index % columnsWidthArray.length]
    : undefined;

  const renderSectionItem = () => {
    if (reportData.type === 'FormField') {
      return (
        <ServiceObjectLabeledText
          key={`${serviceObject.id}-${reportData.fieldData?.id || ''}`}
          serviceObjectId={serviceObject.id}
          fieldData={(reportData.fieldData as MappedCustomDataServiceObjectField)!}
        />
      );
    }

    const relatedFieldValue = reportData.values?.find(
      (x) => x.serviceObjectId === serviceObject.id
    )?.value;

    return (
      <LabeledText
        label={reportData.properties?.label || ''}
        value={relatedFieldValue || ''}
        key={`${serviceObject.id}-${reportData.properties?.template || ''}`}
      />
    );
  };

  return (
    <div
      className="SectionContent_Item"
      style={flexWidth ? { flex: `${flexWidth} 1 ${flexWidth}%` } : undefined}
    >
      {renderSectionItem()}
    </div>
  );
};

export default ServiceObjectSectionItem;
